import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import { SHOW_TICKET_ALERT_STORAGE_KEY } from '@/constants/common';
import { LOGIN_URL, TOKEN_STORAGE_KEY } from '@/hooks/Auth.hooks';

// This component logs the user out and redirects them to the login page
// it is needed because the Auth0 logout function only works within a react component
const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(SHOW_TICKET_ALERT_STORAGE_KEY);
    logout({
      logoutParams: { returnTo: LOGIN_URL }
    });
  }, [logout]);

  return null;
};

export default Logout;
